<ion-card class="card-with-close">
  <div class="card-block">
    <img #imageRef [attr.src]="imageUrl"
      (error)="handleImageError(imageRef, defaultMachineImage)"
       alt="machine-image"
       loading="lazy"
      class="card-contain-img">
    <ion-radio *ngIf="showRadioButton" slot="start" [value]="item"></ion-radio>
    <ion-icon *ngIf="showDeleteMachineImageButton" name="close-circle-outline" class="close-icon" (click)="clickDeleteMachineImageButton(item)"></ion-icon>
  </div>
</ion-card>